export const COUNTRIES = [
  { code: 'US', name: 'United States' }, { code: 'GB', name: 'United Kingdom' },
  { code: 'DE', name: 'Germany' }, { code: 'FR', name: 'France' },
  { code: 'CA', name: 'Canada' }, { code: 'AU', name: 'Australia' },
  { code: 'JP', name: 'Japan' }, { code: 'KR', name: 'South Korea' },
  { code: 'CN', name: 'China' }, { code: 'IN', name: 'India' },
  { code: 'SG', name: 'Singapore' }, { code: 'IL', name: 'Israel' },
  { code: 'NL', name: 'Netherlands' }, { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' }, { code: 'IE', name: 'Ireland' },
  { code: 'BR', name: 'Brazil' }, { code: 'AE', name: 'UAE' },
  { code: 'HK', name: 'Hong Kong' }, { code: 'ES', name: 'Spain' },
  { code: 'IT', name: 'Italy' }, { code: 'PL', name: 'Poland' },
  { code: 'MX', name: 'Mexico' },
];

export const COUNTRY_NAME: Record<string, string> = Object.fromEntries(
  COUNTRIES.map((c) => [c.code, c.name])
);

export const JOB_TITLES = [
  'Software Engineer',
  'Senior Software Engineer',
  'Staff Engineer',
  'Principal Engineer',
  'Engineering Manager',
  'Director of Engineering',
  'VP of Engineering',
  'CTO',
  'Data Scientist',
  'ML Engineer',
  'Product Manager',
  'Designer',
  'DevOps / SRE',
  'Solutions Architect',
  'Data Analyst',
  'Research Scientist',
  'Technical Lead',
  'QA Engineer',
  'Security Engineer',
  'Other',
];
